import { lazy, Suspense } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
import { useAuthContext } from 'src/auth/hooks';
import { CONFIG } from 'src/config-global';
import { SplashScreen } from 'src/components/loading-screen';

import { authRoutes } from './auth';
import { dashboardRoutes, dashboardRoutesAdmin } from './dashboard';

const Page404 = lazy(() => import('src/pages/error/404'));

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={CONFIG.auth.redirectPath} replace />,
    },

    {
      path: '/404',
      element: <Page404 />,
    },

    // Auth
    ...authRoutes,

    // Dashboard
    ...dashboardRoutesAdmin(),

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
